import { GET_APPROVAL_LEAVE } from "@/store/modules/mutation-types";

export default {
  actions: {
    async [GET_APPROVAL_LEAVE]({ dispatch }, params) {
      console.log("GET_APPROVAL_LEAVE");
      const res = await dispatch("apiGet", {
        url: "/kanri/approval_leaves",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  }
};
